import request from "@/utils/request";

export default function getGroupList() {
    return request({
        url: `/device/deviceGroup/getGroupList`,
        method: 'post',
    })
}